import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
	AfterContentInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewEncapsulation,
	ContentChild
} from '@angular/core';

import { merge, of as observableOf, Subscription } from 'rxjs';
import { FLXDatepickerComponent } from '../datepicker.component';
import { DatepickerIntl } from '../helpers/datepicker-intl';
import { DatepickerToggleIconDirective } from './datepicker-toggle-icon.directive';

// /** Can be used to override the icon of a `erDatepickerToggle`. */
// @Directive({
//   selector: '[erDatepickerToggleIcon]'
// })
// export class DatepickerToggleIconDirective {
// }

@Component({
	// moduleId: module.id,
	selector: 'flx-datepicker-toggle',
	templateUrl: './datepicker-toggle.html',
	host: {
		class: 'flx-datepicker-toggle',
		'[class.flx-datepicker-toggle-active]': 'datepicker && datepicker.opened'
	},
	exportAs: 'erDatepickerToggle',
	encapsulation: ViewEncapsulation.None,
	preserveWhitespaces: false,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerToggleComponent<D> implements AfterContentInit, OnChanges, OnDestroy {
	private _stateChanges = Subscription.EMPTY;

	/** Datepicker instance that the button will toggle. */
	@Input('for') datepicker: FLXDatepickerComponent<D>;

	/** Whether the toggle button is disabled. */
	@Input()
	get disabled(): boolean {
		return this._disabled === undefined ? this.datepicker.disabled : this._disabled;
	}

	set disabled(value: boolean) {
		this._disabled = coerceBooleanProperty(value);
	}

	private _disabled: boolean;

	/** Custom icon set by the consumer. */
	@ContentChild(DatepickerToggleIconDirective, { static: true })
	_customIcon: DatepickerToggleIconDirective;

	constructor(public _intl: DatepickerIntl, private _changeDetectorRef: ChangeDetectorRef) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.datepicker) {
			this._watchStateChanges();
		}
	}

	ngOnDestroy() {
		this._stateChanges.unsubscribe();
	}

	ngAfterContentInit() {
		this._watchStateChanges();
	}

	_open(event: Event): void {
		if (this.datepicker && !this.disabled) {
			this.datepicker.open();
			event.stopPropagation();
		}
	}

	private _watchStateChanges() {
		const datepickerDisabled = this.datepicker ? this.datepicker._disabledChange : observableOf();

		const inputDisabled = this.datepicker && this.datepicker._datepickerInput ? this.datepicker._datepickerInput._disabledChange : observableOf();

		const datepickerToggled = this.datepicker ? merge(this.datepicker.openedStream, this.datepicker.closedStream) : observableOf();

		this._stateChanges.unsubscribe();
		this._stateChanges = merge<any>(
			// this._intl.changes,
			datepickerDisabled,
			inputDisabled,
			datepickerToggled
		).subscribe(() => this._changeDetectorRef.markForCheck());
	}
}
